<style lang="scss" scoped>
.story-card {
    display: block;
    min-height: 333px;
    position: relative;

    &:hover {
        text-decoration: none;

        .background-wrapper {
            transform: scale(1.1);
        }
    }

    &:after {
        content: "";
        z-index: 1;
        top: 0;
        left: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        background-image: linear-gradient(
            45deg,
            rgba(0, 0, 0, 0.5) 0%,
            rgba(0, 0, 0, 0) 100%
        );
    }

    .zoom-wrapper {
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: 4px;
        overflow: hidden;
    }

    .background-wrapper {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        transition: transform 0.15s;
        -webkit-backface-visibility: hidden;
    }

    .content {
        position: absolute;
        top: 0;
        z-index: 2;
        line-height: 1;
    }
}
</style>

<template>
    <a v-if="story" class="story-card w-100 h-100" :href="route('nl.story', {'slug': story.slug})">
        <div class="zoom-wrapper" v-if="story.acf.image">
            <div class="background-wrapper w-100 h-100" :style="`background-image: url('${story.acf.image.sizes.large}')`">
            </div>
        </div>

        <div class="content d-flex w-100 h-100 flex-column justify-content-end p-24 p-lg-40">
            <h3 class="mb-16 text-white" v-html="story.title.rendered"></h3>
            <div class="d-block">
                <span class="text-white">{{ story.acf.author }}</span><span class="text-white font-weight-light">&nbsp;-&nbsp;{{ story.acf.participants }}</span>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: "elements.story-card",

    props: {
        story: {
            type: Object,
            required: false,
        },
    },
}
</script>